import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFLookupVendorInvoice } from "src/components/Shared/NewForms/NFLookupVendorInvoice";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFLookupAccount } from "src/components/Shared/NewForms/NFLookupAccount";
import { NFLookupVatType } from "src/components/Shared/NewForms/NFLookupVatType";
import { useTranslation } from "react-i18next";
export const ImportsDetailVats = () => {
    const { t } = useTranslation();

    return (
        <>
            <NFormTable fieldArray={"vats"}>
                <NFLookupProduct fieldName={"productId"} title={t("Product")} />
                <NFLookupVendorInvoice
                    fieldName={"vendorInvoice"}
                    title={t("VendorInvoice")}
                />
                <NFIntInput
                    fieldName={"quantity"}
                    title={t("Quantity")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"customsCost"}
                    title={t("CustomCost")}
                    width={100}
                />
                <NFIntInput fieldName={"tax"} title={t("Tax")} width={100} />
                <NFLookupVatType
                    fieldName="vatRate"
                    title={t("VatRate")}
                    width={200}
                />
                <NFIntInput fieldName={"vat"} title={t("VAT")} width={100} />
                <NFTextInput
                    fieldName="importVatAccountId"
                    title={t("VatAccount")}
                />
                <NFLookupAccount
                    fieldName="treasuryAccountId"
                    title={t("TreasuryAccount")}
                />
                <NFLookupAccount
                    fieldName="vatOverlapReportId"
                    title={t("VATOverlapReport")}
                />
            </NFormTable>
        </>
    );
};
